/** Textos do calendário e da aba Lista (WhatsApp recebidos / a serem enviados). */

export const LEMBRETES_CLIENT_FALLBACK = 'Cliente';

/** Rótulo no menu lateral (seção principal). */
export const LEMBRETES_APP_NAV_LABEL = 'Envios';

export const LEMBRETES_SECTION_TITLE = 'Envios de lembretes';
export const LEMBRETES_SECTION_SUBTITLE =
  'Calendário com envios por dia; na lista, veja recebidos e mensagens a serem enviadas.';

export const LEMBRETES_CAL_TITLE = 'Calendário de envios';
export const LEMBRETES_CAL_PREV_MONTH = 'Mês anterior';
export const LEMBRETES_CAL_NEXT_MONTH = 'Próximo mês';

export const LEMBRETES_TAB_CALENDARIO = 'Calendário';
export const LEMBRETES_TAB_LISTA = 'Lista';
export const LEMBRETES_TABLIST_ARIA_LABEL = 'Abas da seção';

export const LEMBRETES_CAL_TAB_HINT =
  'Cada dia mostra quantos WhatsApp foram enviados e o funil (contatados e agendados), ou lembretes a serem enviados com manutenção prevista na data. Ao escolher um dia, a lista aparece abaixo da legenda. Use a aba Lista para ver tudo de uma vez.';

export const LEMBRETES_CHK_ENVIADOS = 'Recebidos';
export const LEMBRETES_CHK_FUTUROS = 'A serem enviados';

export const LEMBRETES_LISTA_INTRO =
  'Marque o que deseja ver. A lista mostra todos os itens da conta; o filtro por dia fica na aba Calendário.';

export const LEMBRETES_CAL_SELECT_DAY_BELOW =
  'Toque em um dia no calendário para ver recebidos e a serem enviados naquela data abaixo da legenda.';

export const LEMBRETES_BADGE_CONTATADO = 'Contatado';
export const LEMBRETES_BADGE_AGENDADO = 'Agendado';
export const LEMBRETES_ACTION_MARK_CONTACT = 'Marcar contato';
export const LEMBRETES_ACTION_MARK_SCHEDULED = 'Registrar agendamento';
export const LEMBRETES_TOAST_CONTACT_OK = 'Contato registrado.';
export const LEMBRETES_TOAST_SCHEDULE_OK = 'Agendamento registrado.';

export const LEMBRETES_SCHEDULE_MODAL_TITLE = 'Agendar manutenção';
export const LEMBRETES_SCHEDULE_MODAL_INTRO =
  'Informe a data em que a manutenção será realizada e o valor a ser cobrado.';
export const LEMBRETES_SCHEDULE_FIELD_DATE = 'Data da manutenção';
export const LEMBRETES_SCHEDULE_FIELD_VALUE = 'Valor cobrado (R$)';
export const LEMBRETES_SCHEDULE_FIELD_VALUE_HINT = 'Ex.: 150,00 ou 1.234,56';
export const LEMBRETES_SCHEDULE_SUBMIT = 'Salvar agendamento';
export const LEMBRETES_SCHEDULE_SAVING = 'Salvando…';
export const LEMBRETES_SCHEDULE_CANCEL = 'Cancelar';
export const LEMBRETES_SCHEDULE_ERR_DATE = 'Escolha a data da manutenção.';
export const LEMBRETES_SCHEDULE_ERR_VALUE = 'Informe um valor válido em reais (ex.: 150,00).';
export const LEMBRETES_LABEL_AGENDADA_PARA = 'Manutenção agendada para:';
export const LEMBRETES_LABEL_VALUE_CHARGED = 'Valor cobrado:';

export const LEMBRETES_LISTA_COMO_FUNCIONA_TITLE = 'Como funciona';
export const LEMBRETES_LISTA_COMO_FUNCIONA_BODY =
  'Recebidos são mensagens de WhatsApp já enviadas ao cliente (7 dias antes, 1 dia antes ou no dia). A serem enviados ainda não foram disparados e seguem a data prevista de manutenção do serviço.';

export const LEMBRETES_LIST_STATUS_ALL =
  'Mostrando itens conforme os filtros acima.';
export const LEMBRETES_LIST_STATUS_DAY_PREFIX = 'Dia no calendário:';
export const LEMBRETES_LIST_STATUS_DAY_SUFFIX =
  'Recebidos filtram pela data de envio; a serem enviados pela data prevista de manutenção.';

export const LEMBRETES_LIST_SECTION_ENVIADOS = 'Recebidos';
export const LEMBRETES_LIST_SECTION_FUTUROS = 'A serem enviados';

export const LEMBRETES_LIST_EMPTY_GLOBAL =
  'Nenhum lembrete encontrado. Ao registrar serviços, os lembretes aparecem aqui.';
export const LEMBRETES_LIST_EMPTY_ENVIADOS =
  'Nenhum WhatsApp recebido ainda. Quando o RetornaAr enviar as mensagens, elas aparecerão aqui.';
export const LEMBRETES_LIST_EMPTY_FUTUROS =
  'Nada a ser enviado. Ao registrar um serviço, um lembrete é criado para a próxima manutenção.';
export const LEMBRETES_LIST_EMPTY_FILTERED =
  'Nenhum recebido com envio neste dia. Escolha outro dia no calendário ou limpe o filtro.';
export const LEMBRETES_LIST_EMPTY_FUTUROS_DAY =
  'Nenhum item a ser enviado com manutenção prevista neste dia.';

export const LEMBRETES_LIST_LOADING = 'Carregando...';
export const LEMBRETES_BADGE_ATRASADO = 'Atrasado';
export const LEMBRETES_LABEL_ENVIADO = 'Recebido:';
export const LEMBRETES_LABEL_PREVISTA = 'Prevista:';
export const LEMBRETES_LABEL_MANUT_PREVISTA = 'Manutenção prevista:';

/** Legenda do calendário: cores → métricas (célula mostra só bolinha + número). */
export const LEMBRETES_CAL_LEGEND_A_RECEBER_TITLE = 'A receber';
export const LEMBRETES_CAL_LEGEND_A_RECEBER_DESC =
  'Lembretes com manutenção prevista nesta data e que ainda não foram enviados.';

export const LEMBRETES_CAL_LEGEND_RECEBIDO_PASSADO_TITLE = 'Recebido (passado)';
export const LEMBRETES_CAL_LEGEND_RECEBIDO_PASSADO_DESC =
  'Quantidade de WhatsApp já enviados naquele dia.';

export const LEMBRETES_CAL_LEGEND_CONTATADOS_TITLE = 'Contatados';
export const LEMBRETES_CAL_LEGEND_CONTATADOS_DESC =
  'Entre esses envios, quantos você já marcou como contatados.';

export const LEMBRETES_CAL_LEGEND_AGENDADOS_TITLE = 'Agendados';
export const LEMBRETES_CAL_LEGEND_AGENDADOS_DESC =
  'Entre esses envios, quantos já têm manutenção agendada.';

/** @deprecated usar LEMBRETES_CAL_LEGEND_RECEBIDO_PASSADO_DESC */
export const LEMBRETES_CAL_LEGEND_RECEBIDOS = LEMBRETES_CAL_LEGEND_RECEBIDO_PASSADO_DESC;
/** @deprecated usar LEMBRETES_CAL_LEGEND_CONTATADOS_DESC */
export const LEMBRETES_CAL_LEGEND_CONTATADOS = LEMBRETES_CAL_LEGEND_CONTATADOS_DESC;
/** @deprecated usar LEMBRETES_CAL_LEGEND_AGENDADOS_DESC */
export const LEMBRETES_CAL_LEGEND_AGENDADOS = LEMBRETES_CAL_LEGEND_AGENDADOS_DESC;

/** @deprecated usar LEMBRETES_LIST_STATUS_ALL */
export const LEMBRETES_LIST_ALL = LEMBRETES_LIST_STATUS_ALL;
/** @deprecated usar LEMBRETES_LIST_STATUS_DAY_PREFIX */
export const LEMBRETES_LIST_FILTERED_PREFIX = LEMBRETES_LIST_STATUS_DAY_PREFIX;

export const LEMBRETES_CAL_CLEAR_DAY = 'Limpar filtro do dia';

/** @deprecated texto removido da célula; legenda + bolinha roxa. */
export const LEMBRETES_CAL_FUTURE_ON_DAY_LABEL = 'A enviar nesta data';

/** Título da caixa de legenda abaixo do calendário. */
export const LEMBRETES_CAL_LEGEND_BOX_TITLE = 'Legenda';

/** Fragmentos para o aria-label do botão de cada dia (acessibilidade). */
export const LEMBRETES_CAL_ARIA_A_RECEBER = 'a receber';
export const LEMBRETES_CAL_ARIA_RECEBIDOS_DIA = 'WhatsApp recebidos neste dia';
export const LEMBRETES_CAL_ARIA_CONTATADOS = 'contatados';
export const LEMBRETES_CAL_ARIA_AGENDADOS = 'agendados';
export const LEMBRETES_CAL_ARIA_SEM_DADOS = 'sem envios neste dia';
